import { trpc } from '@tencent/tpro_rmonitor_manage_server_app_manage';
import { getUserId } from '@/infrastructure/auth';
import { getAxios } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import { appManagerService } from '@/service/app-manager';
import { WithTypeCast } from '@raft/utils';
import { AddAppReq } from './create-app';
type IDepartment = WithTypeCast<trpc.rmonitor.manage_server.IDepartment>;


export interface DepartmentListItem {
  enabled: boolean;
  id: number;
  leaderId: number;
  level: number;
  name: string;
  parentId: number;
  secretaryId: number;
  typeId: string;
  vicePresidentId: number;
}

export const exitApp = async (params: { appId: string, pid: number }) => {
  try {
    const res = await getAxios().post(`/${API_PREFIX}/api/member/exit-app`, {}, {
      params: {
        appId: params.appId,
        pid: params.pid,
        userIds: getUserId(),
        newUserId: getUserId(),
      },
      headers: {
        'X-ProductID': params.appId,
      },
    });
    return res.data;
  } catch (e) {
    logger.error('exitApp:', e);
    return [];
  }
};

export const GetDepartmentsByUser = async (): Promise<IDepartment[]> => {
  try {
    const res  = appManagerService.getDepartmentsByUser({
      user: getUserId(),
    });
    return res;
  } catch (e) {
    logger.error('GetDepartmentsByUser:', e);
    return [];
  }
};

// 创建产品，调bugly注册接口
export const addApp = async (body: AddAppReq) => {
  try {
    const res = await getAxios().post(`/${API_PREFIX}/api/app/add`, { ...body });
    return res.data;
  } catch (e) {
    logger.error('initApp:', e);
    return null;
  }
};

// 超管搜索所有产品
export const searchAllApp = async (params: { name: string }) => {
  try {
    const res = await getAxios().get(`/${API_PREFIX}/api/app/search-all`, {
      params: {
        searchParam: params.name,
      },
    });
    return res.data;
  } catch (e) {
    logger.error('searchAllApp:', e);
    return null;
  }
};


export const getAppList = async () => {
  try {
    const res = await getAxios().get(`/${API_PREFIX}/api/init`);
    return res.data.appList;
  } catch (e) {
    logger.error('searchAllApp:', e);
    return null;
  }
};
